import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';

import { GROUP_WEEKDAY_KEYS } from '@/constants';

type WeekdayPickerProps = {
  weekdays: readonly number[];
  value: number[];
  error?: string;
  onToggle: (weekday: number) => void;
};

export const WeekdayPicker = (props: WeekdayPickerProps) => {
  const { weekdays, value, error, onToggle } = props;
  const { t } = useTranslation();

  const label = t('Weekdays');

  return (
    <div className="grid gap-2">
      <span
        className={cn(
          'text-xs font-medium',
          error ? 'text-destructive-soft-foreground' : 'text-muted-foreground',
        )}
      >
        {label}
      </span>
      <div
        className={cn(
          'rounded-md border-2',
          'bg-card border',
          error ? 'border-destructive' : 'border-input',
        )}
      >
        <div className="flex flex-wrap gap-2 p-3">
          {weekdays.map((weekday) => {
            const isPicked = value.includes(weekday);

            return (
              <Button
                key={weekday}
                type="button"
                variant={isPicked ? 'default' : 'outline'}
                className="min-w-16"
                aria-pressed={isPicked}
                onClick={() => onToggle(weekday)}
              >
                {t(GROUP_WEEKDAY_KEYS[weekday])}
              </Button>
            );
          })}
        </div>
      </div>

      {!!error && (
        <p className="text-destructive-soft-foreground text-sm">{error}</p>
      )}
    </div>
  );
};
